import { Component, OnDestroy, OnInit, inject, input, output, viewChild, ChangeDetectionStrategy, signal } from '@angular/core';
import { DrawSeatMapsService } from '../draw-seat-maps.service';

import { SeatMapService } from '../seat-map.service';
import * as d3 from 'd3';
import { BehaviorSubject, Subscription} from 'rxjs';

import { Platform } from '@angular/cdk/platform';
import { SyosVenueDetails } from '../../../models/syos-venue-details';
import { SyosSeat } from '../../../models/syos-seat';
import { SeatsSelected } from '../../../models/seats-selected';
import { SyosSection } from '../../../models/syos-section';
import { ZoomInterface, ZoomService } from '../../control-zoom/zoom.service';
import { MatMenu } from '@angular/material/menu';
import { deleteSeatsSelected, getReelNbQtyStep } from '../../../utils/utilsShared';
import { NgStyle } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ControlZoomComponent } from '../../control-zoom/control-zoom.component';
import { Cart } from '../../../models/cart';

@Component({
    selector: 'lib-draw-seatsmap-sale',
    templateUrl: './draw-seatsmap-sale.component.html',
    styleUrls: ['./draw-seatsmap-sale.component.css'],
    imports: [NgStyle, MatProgressSpinner, ControlZoomComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawSeatsmapSaleComponent implements OnInit, OnDestroy {
    seatMapService = inject(SeatMapService);
    _platform = inject(Platform);
    drawSeatMapsService = inject(DrawSeatMapsService);

    zoomActive = true;
    _smallSeatMap = false;
    watchStartSeatsManager = new BehaviorSubject<number | null>(null);

    onSeatsSelected = false;
    myMenu = viewChild<MatMenu>('menu');

    venue = input.required<SyosVenueDetails>();
    eventId = input.required<number>();
    isSubscription = input<boolean>(false);
    inputFilterPriceLevels = input<number[]>([], { alias: 'filterPriceLevels' });
    httpParams = input<any>();
    cartService = input<any>();
    websiteSaleService = input<any>();
    twoFingersDrag = input<boolean>(false);

    messages = output<any>();
    hideZoom = input<boolean>(false);

    width = signal(900);
    height = signal(800);
    scaleFactor!: number;
    originalScaleFactor = 40;
    seatSizeFactor = 0.4;
    d3 = d3;
    zoom: any = null;

    seatsHover = signal<SyosSeat[]>([]);
    seatSelected = signal<SeatsSelected>(<SeatsSelected>{});
    listSeatSelectedLocal = signal<SeatsSelected[]>([]);
    isMobil = false;
    activeSelectSeats = true;
    MIN_SHOW_POLYGON = 0;
    sub: Subscription[] = [];
    facilityId = [1411850201];
    startZoom = false;
    load = signal(false);
    positionToolTip = signal({ x: 0, y: 0 });

    filterPriceLevels: number[] = [];
    qtySelected = 0;

    constructor() {
        this.isMobil = this._platform.ANDROID || this._platform.IOS;
    }

    zoomedV4 = (event: d3.D3ZoomEvent<any, any>) => {
        if (this.zoomActive) {
            const t = event.transform;

            ZoomService.zoomCurrent = t;
            console.log(t);
            DrawSeatMapsService.containerSvg.attr('transform', t.toString());
            if (this.startZoom && !this.seatMapService.smallSeatsMap) {
                DrawSeatMapsService.getPolygonShowInMap(this.venue());
                this.watchStartSeatsManager.next(new Date().getTime());
            }
        }
    };

    ngOnInit() {
        this.filterPriceLevels = this.inputFilterPriceLevels();
        this.onSeatsSelected = false;

        const zoom = d3
            .zoom()
            .scaleExtent([0.1, 3])
            .filter((event: any) => {
                if (event.type === 'touchstart' || event.type === 'touchmove') {
                    if (this.twoFingersDrag() && this.isMobil) {
                        return event.touches && event.touches.length >= 2;
                    }
                }
                return (!event.ctrlKey || event.type === 'wheel') && !event.button;
            })
            .on('zoom', this.zoomedV4);

        const chartCt = document.querySelector('#chartCt') as HTMLElement;
        this.width.set(chartCt?.offsetWidth || 900);
        this.height.set(chartCt?.offsetHeight || 600);

        DrawSeatMapsService.filterPriceLevels = this.filterPriceLevels;
        DrawSeatMapsService.createConstructor(d3, zoom, this.width(), this.height());
        this.drawSeatMap();

        setTimeout(() => {
            this.cartService()?.getCart().subscribe();
            if (this.seatMapService.getSubSeatSelected()?.length > 0) {
                DrawSeatMapsService.addStyleForHoverOrSelectSeat(
                    this.seatMapService.getFormatSubSeatSelected(this.listSeatSelectedLocal()),
                    true,
                );
            }
        }, 2000);

        const a = this.seatMapService.watchSubCart().subscribe((value: Cart) => {
            if (value) {
                d3.selectAll('.reserve-cart').remove();
                DrawSeatMapsService.addReserveTag(value, this.eventId(), this.isSubscription());
            }
        });

        const b = this.seatMapService.watchQtySeatMapBySelect().subscribe((value: any) => {
            this.load.set(true);
            setTimeout(() => {
                this.changeQtySelect(value);
            }, 2000);
        });

        const d = this.seatMapService.watchSubBestSeatSelect().subscribe((value: any) => {
            this.activeSelectSeats = !value;
        });

        const f = DrawSeatMapsService.watchZoomPolygons.asObservable().subscribe((value: any) => {
            if (value !== null) {
                setTimeout(() => {
                    this.watchStartSeatsManager.next(new Date().getTime());
                }, 2000);
            }
        });

        const j = DrawSeatMapsService.watchZoom.asObservable().subscribe((value: any) => {});

        const k = DrawSeatMapsService.listenEventsSeats.asObservable().subscribe((value: any) => {
            if (value) {
                this.manageSeatsEvent(value);
            }
        });

        const l = this.watchStartSeatsManager.asObservable().subscribe((value: any) => {
            if (value && !this._smallSeatMap) {
                this.doStartEventSeats();
            }
        });

        const p = ZoomService.watchZoom.asObservable().subscribe((value: any) => {
            console.log(value);
            if (ZoomService.bodySvg && ZoomService.instance) {
                ZoomService.zoomCurrent = value.zoomIdentity;
                ZoomService.instance.transform(ZoomService.bodySvg, value.zoomIdentity);
            }
        });

        const aa = this.seatMapService.watchSeatSelected().subscribe((value: SeatsSelected[]) => {
            const currentSeatSelection = this.seatMapService.getSubSeatSelectedValue();
            DrawSeatMapsService.removeStyleForHoverOrSelectSeat(this.getReserveTemp(), true);
            this.listSeatSelectedLocal.set(currentSeatSelection?.filter((val) => val.eventId === this.eventId()) || []);

            DrawSeatMapsService.addStyleForHoverOrSelectSeat(
                this.seatMapService.getFormatSubSeatSelected(this.listSeatSelectedLocal()),
                true,
            );
        });

        const bb = this.seatMapService.subSeatSelectedToRemove.asObservable().subscribe((value: any) => {
            value?.seats?.forEach((seatSelect: any) => {
                seatSelect?.data?.forEach((seat: any) => {
                    this.preRemoveSeat(seat, value.oberve !== undefined ? value.oberve : true);
                });
            });
        });

        const dd = DrawSeatMapsService.priceLevelSelected.subscribe((value: any) => {
            if (value === null) {
                return;
            }
            if (value && value > 0) {
                this.filterPriceLevels = [value];
            } else {
                this.filterPriceLevels = [];
            }

            this.changeQtySelect(this.qtySelected, true);
        });

        const ee = this.seatMapService.subDrawByFilterPriceLevels.asObservable().subscribe((drawFilterBypriceLevels: any[]) => {
            if(drawFilterBypriceLevels !== null){
                this.filterByPriceLevelSeatMapView()
            }            
        });

        this.sub = [a, b, d, f, j, k, l, p, aa, bb, dd, ee].filter((s) => !!s);
    }

    private changeQtySelect(value: number, active = false) {
        try {
            if (this.qtySelected !== value || active) {
                this.qtySelected = value;
                const enableSt = this.enableSeat();

                let p: d3.Selection<d3.BaseType, unknown, HTMLElement, any> | undefined;
                let combinedNodes: any[] = [];
                if (this.filterPriceLevels.length > 0) {
                    this.filterPriceLevels.forEach((val) => {
                        const nodes = d3.selectAll('.priceLevelId-' + val).nodes();
                        combinedNodes = combinedNodes.concat(nodes);
                    });
                } else {
                    p = d3.selectAll('.sellable');
                }
                if (combinedNodes.length > 0) {
                    p = d3.selectAll(combinedNodes);
                }
                d3.selectAll('.circle-seat').classed('not-sellable-seat', true);
                if (this.qtySelected > 1) {
                    const pSeat: any[] = [];
                    p!.each((seatData: any) => {
                        const temp = DrawSeatMapsService.getValidSeatsOnSale(
                            seatData.data,
                            this.qtySelected,
                            this.venue().avoidSingle,
                            enableSt,
                            this.seatMapService.subValidQtyDemande.value,
                        );
                        temp.forEach((value1: any) => {
                            const idSeat = value1.id;

                            if (pSeat.find((st) => st.id === idSeat) === undefined) {
                                pSeat.push(value1);
                                d3.select('#circle-seat' + idSeat).classed('not-sellable-seat', false);
                            }
                        });
                    });
                } else {
                    p!.each((seatData: any) => {
                        d3.select('#circle-seat' + seatData.data.id).classed('not-sellable-seat', false);
                    });
                }
                if (this.listSeatSelectedLocal()?.length > 0) {
                    DrawSeatMapsService.addStyleForHoverOrSelectSeat(
                        this.seatMapService.getFormatSubSeatSelected(this.listSeatSelectedLocal()),
                        true,
                    );
                }

                this.clearSeats();
            }
        } catch (e) {
            this.load.set(false);
        }

        this.load.set(false);
    }

    ngOnDestroy(): void {
        d3.selectAll('.' + DrawSeatMapsService.constSeatMap.SEAT)
            .on('touchstart', null)
            .on('touchend', null)
            .on('touchmove', null)
            .on('touchcancel', null)
            .on('mousedown', null)
            .on('click', null)
            .on('mouseover', null)
            .on('mouseout', null)
            .remove();
        d3.select('#venue' + this.venue().id).remove();
        this.clearSeats();
        this.sub.forEach((value) => {
            if (value) {
                value.unsubscribe();
            }
        });
    }

    doStartEventSeats() {
        const venue = this.venue();
        const svgVenue = d3.select('#venue' + venue.id);
        DrawSeatMapsService.drawSeatsInPolygonZoomOut(svgVenue, venue, this.eventId(), this.isSubscription(), this.httpParams()).finally(
            () => {
                DrawSeatMapsService.addStyleForHoverOrSelectSeat(
                    this.seatMapService.getFormatSubSeatSelected(this.listSeatSelectedLocal()),
                    true,
                );
                this.filterByPriceLevelSeatMapView();
            },
        );
    }

    updateSeatWithPrice() {
        const venue = this.venue();
        venue.levels.forEach((level) => {
            level.sections.forEach((section) => {
                DrawSeatMapsService.getPriceForSeatBySectionId(
                    this.eventId(),
                    this.isSubscription(),
                    <SyosSection>{ id: section.id },
                    venue,
                    this.httpParams(),
                );
            });
        });
    }

    doCenterSeatsMap() {
        const a = document.querySelector('#chart');
        if (!a) return;
        const bbox2 = a.getBoundingClientRect();

        const vw = bbox2.width;
        const vh = bbox2.height;
        const bbox = DrawSeatMapsService.containerSvg.node()?.getBBox();
        if (!bbox) return;

        const bw = bbox.width;
        const bh = bbox.height;
        const x = Math.floor(bbox.x + bbox.width / 2.0);
        const y = Math.floor(bbox.y + bbox.height / 2.0);

        const scale = Math.max(0, Math.min(8, 0.9 / Math.max(bw / vw, bh / vh)));
        const translate = [vw / 2 - scale * x, vh / 2 - scale * y];
        ZoomService.scaleInit = d3.zoomIdentity.translate(translate[0], translate[1]).scale(scale);
        ZoomService.watchZoom.next(<ZoomInterface>{
            zoomIdentity: d3.zoomIdentity.translate(translate[0], translate[1]).scale(scale),
            action: 'm',
        });
        setTimeout(() => {
            this.startZoom = true;
        }, 2000);
    }

    manageSeatsEvent(value: { event: string; listener: any; data: { data: SyosSeat; priceLevelId: number } }) {
        this.positionToolTip.set({
            x: value.listener.pageX,
            y: value.listener.pageY,
        });
        document.querySelector('.tooltip');
        if (!value) {
            return;
        }
        if (!this.activeSelectSeats) {
            return;
        }

        if (value.event === 'click') {
            if (!this.seatMapService.subOptionMultiSelect.value) {
                DrawSeatMapsService.removeStyleForHoverOrSelectSeat(
                    this.seatMapService.getFormatSubSeatSelected(this.listSeatSelectedLocal()),
                    true,
                );
                this.seatMapService.clearSubSeatSelected(this.eventId());
            } else {
                const st = value?.data?.data;
                const isAlreadySeatSelected = this.seatMapService.isSelectedSeat(st.id);
                if (!this.seatsHover() || this.seatsHover().length === 0) {
                    this.preRemoveSeat(st);
                }
                if (isAlreadySeatSelected) {
                    return;
                }
            }

            if (this.isMobil) {
                const enableSt = this.enableSeat();

                const seatsHoverTemp = DrawSeatMapsService.getValidSeatsOnSale(
                    value.data.data,
                    this.qtySelected,
                    this.venue().avoidSingle,
                    enableSt,
                    this.seatMapService.subValidQtyDemande.value,
                );
                this.seatsHover.set(this.clearSeatSelectFromHoverSeat(seatsHoverTemp, this.qtySelected));
                if (this.seatsHover().length > 0) {
                    DrawSeatMapsService.addStyleForHoverOrSelectSeat(this.seatsHover());
                }
            }

            if (this.seatsHover() && this.seatsHover().length > 0) {
                this.seatSelected.update((ss) => ({ ...ss, data: this.seatsHover() }));
                this.addSeatReserveTemp(value);
            }
            this.seatsHover.set([]);
            DrawSeatMapsService.addStyleForHoverOrSelectSeat(
                this.seatMapService.getFormatSubSeatSelected(this.listSeatSelectedLocal()),
                true,
            );
        }
        if (value.event === 'mouseover') {
            if (!value?.data?.priceLevelId) {
                return;
            }
            if (DrawSeatMapsService?.priceLevelSelected?.value) {
                if (value.data && value.data.priceLevelId) {
                    if (DrawSeatMapsService.priceLevelSelected.value !== value.data.priceLevelId) {
                        return;
                    }
                }
            }
            const hoveredPriceLevel = this.seatMapService.getPriceLevel(this.venue().priceLevels, value.data.priceLevelId);
            if (hoveredPriceLevel?.soldout || hoveredPriceLevel?.limitReached) {
                return;
            }
            let enableSt = this.enableSeat();
            const temp = DrawSeatMapsService.getValidSeatsOnSale(
                value.data.data,
                this.qtySelected,
                this.venue().avoidSingle,
                enableSt,
                this.seatMapService.subValidQtyDemande.value,
            );
            this.seatsHover.set(this.clearSeatSelectFromHoverSeat(temp, this.qtySelected));
            if (this.seatsHover()) {
                DrawSeatMapsService.addStyleForHoverOrSelectSeat(this.seatsHover());
            }
            this.activeTooltip();
        }
        if (value.event === 'mouseout') {
            DrawSeatMapsService.removeStyleForHoverOrSelectSeat(this.seatsHover());
            this.clearTooltip();
        }
    }

    preRemoveSeat(st: SyosSeat, oberve = true) {
        if (this.venue().avoidSingle) {
            let sLocal = this.seatMapService.getFormatSubSeatSelected(this.listSeatSelectedLocal(), st.id);
            let nfilter = deleteSeatsSelected(sLocal, st, this.qtySelected);

            nfilter?.forEach((seat) => {
                this.seatMapService.removeSeatReserveTemp(seat, oberve);
            });
        } else {
            this.seatMapService.removeSeatReserveTemp(st, oberve);
        }
    }
    removeAllSeatsSelected(oberve = true) {
        const sLocal = this.seatMapService.getSubSeatSelected(this.eventId());
        sLocal?.forEach((seat) => {
            this.preRemoveSeat(seat, oberve);
        });
    }

    addSeatReserveTemp(value: { event: string; listener: any; data: { data: SyosSeat; priceLevelId: number } }) {
        if (value.data && value.data.priceLevelId && value.data.priceLevelId > 0) {
            const temp = this.seatMapService.getPriceLevel(this.venue().priceLevels, value.data.priceLevelId);

            this.seatSelected.update((ss) => {
                const newSs = { ...ss, prices: temp.prices };
                const hasNeedSplitPrice = newSs.prices.length > 1;

                newSs.prices.forEach((value1, index) => {
                    if (index === 0) {
                        value1.qty = this.qtySelected;
                        value1.maxQty = this.qtySelected;
                        value1.seatIds = newSs.data.map((value2) => {
                            const note = DrawSeatMapsService.getNote(value2.id);
                            value2.note = note;
                            return value2.id;
                        });
                        newSs.seatIds = newSs.data.map((value2) => value2.id);
                        value1.confirmed = !hasNeedSplitPrice;
                    } else {
                        value1.qty = 0;
                        value1.maxQty = 0;
                    }
                });
                newSs.notes = [];
                newSs.seatIds.forEach((idSeat) => {
                    const note = DrawSeatMapsService.getNote(idSeat);
                    if (note) {
                        newSs.notes.push(note);
                    }
                });
                newSs.priceLevelId = value.data.priceLevelId;
                newSs.colorPriceLevel = temp.color;
                newSs.prices[0].qty = newSs.prices[0].seatIds.length;
                if (newSs.prices.length === 1) {
                    newSs.data.forEach((value1) => {
                        value1.priceSelected = newSs.prices[0];
                    });
                }

                newSs.left = value.listener.x;
                newSs.top = value.listener.y;
                newSs.eventId = this.eventId();
                return newSs;
            });
        } else {
            this.seatSelected.update((ss) => {
                const newSs = { ...ss };
                newSs.left = value.listener.x;
                newSs.top = value.listener.y;
                newSs.eventId = this.eventId();
                return newSs;
            });
        }

        this.seatMapService.addSubSeatSelected(this.seatSelected());
    }

    enableSeat() {
        return this.facilityId.find((ids) => ids === this.venue().facilityId) !== undefined;
    }

    clearSeatSelectFromHoverSeat(syosSeat: SyosSeat[], qtySelected: number) {
        let temp = syosSeat.filter((value) => !this.hasSeatSelectedById(value.id));
        if (!temp && temp.length === 0) {
            return [];
        }
        if (this.filterPriceLevels?.length > 0) {
            temp = temp.filter((value) => this.filterPriceLevels.includes(value.priceLevelId));
        }
        qtySelected = getReelNbQtyStep(qtySelected, temp[0]?.minTicket);
        if ((temp.length > 0 && temp.length <= qtySelected) || temp.length === 2 || temp.length === 3) {
            return syosSeat;
        }
        return [];
    }

    hasSeatSelectedById(id: any): boolean {
        let list = <SeatsSelected[]>this.seatMapService.getSubSeatSelectedValue();
        if (!list) {
            return false;
        }
        list = list.filter((value) => value.eventId === this.eventId());
        return list.find((value) => value.seatIds.includes(id)) !== undefined;
    }

    getReserveTemp() {
        let a: SyosSeat[] = [];
        d3.selectAll('.reserve-temp').each(function (d: any) {
            if (d?.data?.id) {
                a.push(<any>{ id: d.data.id });
            }
        });
        return a;
    }

    drawSeatMap(val?: boolean) {
        const venue = this.venue();
        if (venue && venue.levels && venue.levels.length > 0 && d3) {
            if (val) {
                venue.levels.forEach(function (level) {
                    level.sections.forEach(function (section) {
                        const lev = DrawSeatMapsService.getGroup('level', level.id);
                        DrawSeatMapsService.drawSectionPolygons(lev, section, level);
                    });
                });
            } else {
                this.seatSizeFactor = venue.seatSizeFactor || this.seatSizeFactor;
                this.scaleFactor = 10;

                DrawSeatMapsService.setSeatSizeFactor(this.seatSizeFactor);
                if (this.seatMapService.smallSeatsMap) {
                    this._smallSeatMap = true;
                    DrawSeatMapsService.drawVenue(venue);
                    this.watchStartSeatsManager.next(new Date().getTime());
                    this.updateSeatWithPrice();
                } else {
                    this._smallSeatMap = false;
                    DrawSeatMapsService.setisPolygonView(true)
                    DrawSeatMapsService.drawVenuePolygon(venue, this.eventId());
                }
                setTimeout(() => {
                    this.doCenterSeatsMap();
                }, 1000);
            }
            venue?.priceLevels?.forEach((value) => {
                let max = 0;
                let min = 1000000;
                value.prices.forEach((value1) => {
                    if (max < value1.price) {
                        max = value1.price;
                    }
                    if (min > value1.price) {
                        min = value1.price;
                    }
                });
                value.max = max;
                value.min = min;
            });
        }
    }

    clearSeats() {
        DrawSeatMapsService.removeStyleForHoverOrSelectSeat(this.seatsHover(), true);
        this.seatsHover.set([]);
        this.onSeatsSelected = false;
        this.seatSelected.set(<SeatsSelected>{});
    }

    actionControlZoom($event: any) {
        if ($event.action === 'zoomHome') {
            DrawSeatMapsService.removeAllSeatsReset();
        }
    }

    hovers(seatsSelected: SeatsSelected, strokeWidth = '1') {
        seatsSelected.data.forEach(function (seat) {
            const seatSvg = DrawSeatMapsService.getSeat(seat.id);
            const circle = seatSvg.select('circle');
            circle.style('stroke-width', strokeWidth);
        });
    }

    clearTooltip() {
        const a = document.getElementById('tkp-tooltip');
    }

    activeTooltip() {
        const a = document.getElementById('tkp-tooltip');
    }
    filterByPriceLevelSeatMapView(isPolugon = false) {
        if(!DrawSeatMapsService.isPolygonView ){
            d3.selectAll('.sellable').style('pointer-events', 'none');
            d3.selectAll('.sellable .circle-seat').classed('hidden', true);

            this.seatMapService.subDrawByFilterPriceLevels.value?.forEach((value) => {
                d3.selectAll('.priceLevelId-' + value).style('pointer-events', 'auto');
                const nodes = d3.selectAll('.priceLevelId-' + value + ' .circle-seat').nodes();
                d3.selectAll(nodes).classed('hidden', false);
            });
        }else{
            d3.selectAll('.sectionPolygon')
            .classed('hidden', true)
            .style('pointer-events', 'none');
            this.seatMapService.subDrawByFilterPriceLevels.value?.forEach((value) => {
                d3.selectAll('.priceLevelId-' + value)
                .classed('hidden', false)
                .style('pointer-events', 'auto');
            
            });           
        }

    }
}
